import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
const questions = ['¿Cómo abro mi cuenta bancaria?', '¿Qué es el Annual Report y cuándo lo presento?', '¿Necesito un Operating Agreement?', '¿Qué estructura elegir?', '¿Cómo cumplir con el IRS?', '¿Qué necesitas para operar correctamente?'];
export function PainSection() {
  return <section className="relative overflow-hidden" data-id="element-279">
      {/* BLOCK 1 — Hero Statement */}
      <div className="py-20 md:py-24 bg-white" data-id="element-280">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-281">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="text-center" data-id="element-282">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold leading-tight mb-6" style={{
            WebkitTextStroke: '0',
            textShadow: 'none'
          }} data-id="element-283">
              <span className="text-[#6B21A8]" style={{
              WebkitTextStroke: '0',
              textShadow: 'none'
            }} data-id="element-284">
                Registrar una empresa es&nbsp;fácil.
              </span>
              <br data-id="element-285" />
              <span className="text-[#6B21A8] italic" style={{
              WebkitTextStroke: '0',
              textShadow: 'none'
            }} data-id="element-286">
                Crearla bien es otra&nbsp;historia.
              </span>
            </h2>

            <p className="text-gray-600 font-light text-lg md:text-xl max-w-2xl mx-auto mb-8" data-id="element-287">
              Todos los días emprendedores latinos dan el paso. Registran
              su&nbsp;LLC. Obtienen su&nbsp;EIN. Sienten que ya
              están&nbsp;listos.
            </p>

            <div className="w-20 h-0.5 bg-inkova-accent mx-auto mb-8" data-id="element-288"></div>

            <p className="text-inkova-primary font-bold text-xl md:text-2xl font-serif" data-id="element-289">
              Y entonces llega la&nbsp;realidad:
            </p>
          </motion.div>
        </div>
      </div>

      {/* BLOCK 3 — Closing Impact */}
      <div className="py-16 md:py-20 bg-[#5a4579]" data-id="element-290">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-291">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="text-center" data-id="element-292">
            <h3 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-white mb-4" data-id="element-293">
              Tener una LLC no es tener un&nbsp;negocio.
            </h3>
            <p className="text-inkova-accent italic text-lg md:text-xl font-serif mb-8" data-id="element-294">
              Es solo el primer&nbsp;paso.
            </p>
            <a href="#planes" className="inline-flex items-center justify-center px-8 py-4 rounded-full bg-inkova-accent text-inkova-primary font-bold text-base md:text-lg hover:bg-white transition-colors duration-300 shadow-lg" data-id="element-295">
              Quiero hacerlo bien desde el&nbsp;inicio
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}